function WarningGlyph({ motion, stale = false, className = "h-5 w-5" }) {
  const status = String(motion ?? "").trim().toUpperCase();
  const blinking = !stale && (status === "MOVING" || status === "WALKING");

  return (
    <svg
      viewBox="0 0 24 24"
      className={`inline-block ${className} ${blinking ? "warning-blink" : ""}`}
      aria-label={blinking ? "Warning, asset moving" : "Warning"}
    >
      <path className="warning-triangle" d="M1 21h22L12 2 1 21z" />
      <path fill="#000" d="M13 18h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  );
}

export default WarningGlyph;
